import Vue from 'vue';
import ElementUI from 'element-ui';
import VeeValidate from 'vee-validate';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';

// import zh from 'vee-validate/dist/locale/zh_CN';
import 'element-ui/lib/theme-chalk/index.css';

import * as http from '@/utils/http';
import store from './store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getConfig, getChannelDataset, getGlobalSearchData } from './utils/utils.js';
import Lockr from 'lockr';
import Permission from './plugins/permission';
import messages from './locales/messages';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import websocket from '@/plugins/websocket';
import { jmUpload, jmDictSelect, crumbs } from '@/components/tool';
import VueNativeNotification from 'vue-native-notification';
import siteInfo from './siteInfo';
import Copy from 'vue-to-copy'; // 复制插件
import Print from 'vue-print-nb';
import { storeInternalIp } from '@/utils/login';
import '@/utils/filters';

const APP_DOMAIN = process.env.VUE_APP_DOMAIN;

Lockr.prefix = `${process.env.VUE_APP_SITE_NAME}_`;

Vue.prototype.$isDev = process.env.NODE_ENV === 'development';

Vue.prototype.$isOnline = APP_DOMAIN === 'jiemo.net';
Vue.prototype.$lockr = Lockr;
Vue.prototype.$siteName = process.env.VUE_APP_SITE_NAME;
Vue.prototype.$noLayout = false;

const sentryUrl = Vue.prototype.$isOnline
  ? 'https://29946098f59745f2a0ad5771064439cd@sentry2.dev.jiemo.net/8'
  : 'https://29946098f59745f2a0ad5771064439cd@sentry2.dev.jiemo.net/8';

!Vue.prototype.$isDev && Raven
  .config(sentryUrl)
  .addPlugin(RavenVue, Vue)
  .install();

require('es6-promise').polyfill();

const config = {
  fieldsBagName: 'validateFields',
  locale: 'zh_CN',
};

Vue.config.productionTip = false;
Vue.config.devtools = Vue.prototype.$isDev;
Vue.config.performance = Vue.prototype.$isDev;

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'zh', // set locale
  fallbackLocale: 'zh',
  messages, // set locale messages
});

ElementLocale.i18n((key, value) => i18n.t(key, value));

/* eslint-disable no-new */
Vue.use(Permission, { store });
Vue.use(ElementUI, { size: 'medium' });
Vue.use(VeeValidate, config);
Vue.use(VueNativeNotification, {
  requestOnNotify: true
});
Vue.use(Copy);
Vue.use(Print);

Vue.component(jmUpload.name, jmUpload);
Vue.component(crumbs.name, crumbs);
Vue.component(jmDictSelect.name, jmDictSelect);

Vue.prototype.$http = http;
Vue.prototype.$jiemo = {
  // imghome: `//imghome.${APP_DOMAIN}`,
  imghome: process.env.VUE_APP_IMG_HOME,
  baseUrl: process.env.BASE_URL,
  storageUrl: process.env.VUE_APP_STORAGE_URL,
};

// 设置按钮默认属性，默认尺寸为“大”（实际无此样式，因必须有值）
Object.defineProperties(ElementUI.Button.props, {
  size: {
    value: { default: 'large', type: String }
  }
});

export default Vue;

function initRemoteDataset() {
  // 渠道数据
  getChannelDataset();
  getGlobalSearchData();
}

export function hookRouter(router, afterGetConfig = null) {
  router.beforeEach((to, from, next) => {
    if (to.meta) {
      // noLayout 模式
      if (to.meta.noLayout) {
        Vue.prototype.$noLayout = true;
      }
      if (to.meta.noAuth) {
        Vue.prototype.$noAuth = true;
      }

      // 无需登陆
      if (to.meta.noAuth) {
        next();
        return true;
      }
    }

    // window.loading = ElementUI.Loading.service({ lock: true, text: '拼命加载中... 如长时间未加载请刷新' });
    NProgress.start();
    NProgress.inc(0.2);
    getConfig(http, to).then(({ menu, userInfo }) => {
      !Vue.prototype.$isDev && Raven.setUserContext(userInfo);
      !Vue.prototype.$isOnline && console.info('role ids', JSON.stringify(userInfo.roleids));
      Vue.use(
        websocket,
        !Vue.prototype.$isOnline ?
          `wss://wss.dev.jiemo.net/9502?site=${Vue.prototype.$siteName}` :
          `wss://wss.jiemo.net/9502?site=${Vue.prototype.$siteName}`, { store, userInfo }
      );
      const siteTile = siteInfo[Vue.prototype.$siteName].title;
      const crumbs = (Object.values(menu.crumbs) || []).join('-') || to.meta.title || '';
      document.title = `${crumbs}--${siteTile}`;

      initRemoteDataset();
      if (afterGetConfig) {
        afterGetConfig(userInfo);
      }
      next();
    });
  });

  router.afterEach((to) => {
    NProgress.done();
    NProgress.remove();
    // window.loading.close();
    if (to.path === '/login' || to.path === '/dingLogin') {
      storeInternalIp();
    }
  });
}
